import { Component, inject, OnDestroy } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { CheckoutMode, InvoicingService } from '../../../core/services/invoicing.service';
import { InvoicePreviewComponent } from '../invoice-preview/invoice-preview.component';
import { TranslatePipe } from '@ngx-translate/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-invoicing-page',
  imports: [InvoicePreviewComponent, TranslatePipe, RouterOutlet],
  templateUrl: './invoicing-page.component.html',
  styleUrl: './invoicing-page.component.scss'
})
export class InvoicingPageComponent implements OnDestroy {
  CheckoutMode = CheckoutMode;

  private invoicingService = inject(InvoicingService);
  public checkoutMode = toSignal(this.invoicingService.checkoutMode$, { initialValue: CheckoutMode.CREATE_FULL_SALE });

  ngOnDestroy(): void {
    this.invoicingService.clearAll();
  }
}
